import { BarChart, Bar, XAxis, Cell, ResponsiveContainer } from "recharts";
import { Theme } from "../../data/style/Theme";

const EmomExerciseChart = (props) => {
  let { data, type } = props;

  return (
    <ResponsiveContainer height={"100%"} width={"100%"}>
      <BarChart margin={{ top: 25, right: 5 }} data={data}>
        <XAxis
          dataKey="acronym"
          tick={{
            fill: Theme.palette.text,
            fontSize: "0.7rem",
            fontFamily: "DM sans",
          }}
        />

        <Bar barSize={25} dataKey="count" label={{ position: "top" }}>
          {data?.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={type === "success" ? Theme.palette.up : Theme.palette.down}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default EmomExerciseChart;
